// Badge.styled.ts
import styled from 'styled-components';

export const Badge = styled.div`
  vertical-align: middle;
  min-width: 16px;
  padding: 0 6px;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
  background: #cc2324;
  border-radius: 16px;
  color: #ffffff;
`;
